export class RegisterRequestParams {
  storeId: guid = '';
  username: string = '';
  firstName: string = '';
  lastName: string = '';
  password: string = '';
  captchaToken: string = '';
  phoneNumber: string = '';
}
